export default __webpack_public_path__ + "static/2-b490ed82608bcf8a517dd0613afee5c5.png";